export default __webpack_public_path__ + "static/media/level3Background.849e2958.jpg";